import { MenuComponent } from 'components/layout/menu';
import React, { useRef, useEffect } from 'react';

export interface MenuItem {
  label: string;
  onClick: (event: React.MouseEvent) => void;
  className?: string;
  disabled?: boolean;
}

interface DropdownMenuProps {
  items: MenuItem[];
  className?: string;
  menuClassName?: string;
}

export const DropdownMenu = ({
  items,
  className = 'menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-150px py-4',
  menuClassName = 'menu-item px-3'
}: DropdownMenuProps) => {
  const menuRef = useRef<HTMLDivElement>(null);
  const menuInstanceRef = useRef<MenuComponent | null>(null);

  useEffect(() => {
    if (menuRef.current) {
      menuInstanceRef.current = new MenuComponent(menuRef.current, {
        dropdown: {
          hoverTimeout: 200,
          zindex: 105
        },
        accordion: {
          slideSpeed: 250,
          expand: false
        }
      });
    }
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        if (menuInstanceRef.current && menuRef.current) {
          menuInstanceRef.current.hide(menuRef.current);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);

      if (typeof MenuComponent !== 'undefined') {
        MenuComponent.hideDropdowns(undefined);
      }

      if (menuInstanceRef.current) {
        if ((menuInstanceRef.current as any)._destroy) {
          (menuInstanceRef.current as any)._destroy();
        }
        menuInstanceRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (menuInstanceRef.current) {
      menuInstanceRef.current.update();
    }
  }, [items]);

  return (
    <div ref={menuRef} className={className} data-kt-menu="true" onClick={(e) => e.stopPropagation()}>
      {items.map((item, index) => (
        <div key={index} className={menuClassName}>
          <a
            className={`menu-link px-3 ${item.className || ''} ${item.disabled ? 'disabled' : ''}`}
            onClick={(e) => {
              e.stopPropagation();
              if (!item.disabled) {
                item.onClick(e);
              }
            }}
            style={{ cursor: item.disabled ? 'not-allowed' : 'pointer' }}
          >
            {item.label}
          </a>
        </div>
      ))}
    </div>
  );
};
